import Backdraft from "backdraft-app/src/backdraft";

Backdraft.app("Shared/SignalExpression", function(app) {
  app.model("AgeTerminal", "NumberCompareTerminal", {
    type: function() {
      return 'Age';
    }
  });
});
